var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOutsourcingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 54,
    viewBox: "0 0 53 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.7288 32.697C6.09552 32.697 3.06413 35.2961 2.41846 38.7362H3.46905C3.73169 37.524 4.34454 36.4428 5.19814 35.591C6.35816 34.4334 7.95593 33.7126 9.7288 33.7126C11.5017 33.7126 13.0994 34.4334 14.2595 35.591C15.1131 36.4428 15.715 37.524 15.9886 38.7362H17.0391C16.3935 35.2961 13.373 32.697 9.7288 32.697Z",
    fill: "url(#paint0_linear_350_14)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71795 32.3147C11.7644 32.3147 13.4278 30.6548 13.4278 28.6126C13.4278 26.5704 11.7644 24.9104 9.71795 24.9104C7.67149 24.9104 6.00806 26.5704 6.00806 28.6126C6.00806 30.6548 7.67149 32.3147 9.71795 32.3147ZM7.58394 26.4939C8.13112 25.9479 8.87529 25.6203 9.707 25.6203C10.5387 25.6203 11.2829 25.9588 11.8301 26.4939C12.3772 27.04 12.7056 27.7826 12.7056 28.6126C12.7056 29.4425 12.3663 30.1852 11.8301 30.7312C11.2829 31.2772 10.5387 31.6049 9.707 31.6049C8.87529 31.6049 8.13112 31.2663 7.58394 30.7312C7.03676 30.1852 6.70845 29.4425 6.70845 28.6126C6.70845 27.7826 7.0477 27.04 7.58394 26.4939Z",
    fill: "url(#paint1_linear_350_14)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5049 32.697C38.8716 32.697 35.8403 35.2961 35.1946 38.7362H36.2452C36.5078 37.524 37.1207 36.4428 37.9743 35.591C39.1343 34.4334 40.7321 33.7126 42.5049 33.7126C44.2778 33.7126 45.8756 34.4334 47.0356 35.591C47.8892 36.4428 48.4911 37.524 48.7647 38.7362H49.8153C49.1696 35.2961 46.1382 32.697 42.5049 32.697Z",
    fill: "url(#paint2_linear_350_14)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7842 28.6126C38.7842 30.6548 40.4476 32.3147 42.4941 32.3147C44.5405 32.3147 46.204 30.6548 46.204 28.6126C46.204 26.5704 44.5405 24.9104 42.4941 24.9104C40.4367 24.9104 38.7842 26.5704 38.7842 28.6126ZM45.4926 28.6126C45.4926 29.4425 45.1534 30.1852 44.6171 30.7312C44.07 31.2772 43.3258 31.6049 42.4941 31.6049C41.6624 31.6049 40.9182 31.2663 40.371 30.7312C39.8238 30.1852 39.4955 29.4425 39.4955 28.6126C39.4955 27.7826 39.8348 27.04 40.371 26.4939C40.9182 25.9479 41.6624 25.6203 42.4941 25.6203C43.3258 25.6203 44.07 25.9588 44.6171 26.4939C45.1534 27.04 45.4926 27.7826 45.4926 28.6126Z",
    fill: "url(#paint3_linear_350_14)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7011 11.8928C22.8611 10.7352 24.4589 10.0144 26.2317 10.0144C28.0046 10.0144 29.6024 10.7352 30.7624 11.8928C31.616 12.7446 32.2179 13.8258 32.4915 15.038H33.5421C32.8964 11.5979 29.865 8.99875 26.2317 8.99875C22.5984 8.99875 19.5671 11.5979 18.9214 15.038H19.972C20.2456 13.8258 20.8584 12.7337 21.7011 11.8928Z",
    fill: "url(#paint4_linear_350_14)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2209 8.60561C28.2673 8.60561 29.9308 6.94565 29.9308 4.90345C29.9308 2.86126 28.2673 1.20129 26.2209 1.20129C24.1744 1.20129 22.511 2.86126 22.511 4.90345C22.511 6.94565 24.1744 8.60561 26.2209 8.60561ZM24.0978 2.78481C24.645 2.23877 25.3892 1.91115 26.2209 1.91115C27.0526 1.91115 27.7968 2.24969 28.3439 2.78481C28.8911 3.33085 29.2194 4.07347 29.2194 4.90345C29.2194 5.73344 28.8802 6.47605 28.3439 7.02209C27.7968 7.56813 27.0526 7.89576 26.2209 7.89576C25.3892 7.89576 24.645 7.55721 24.0978 7.02209C23.5506 6.47605 23.2223 5.73344 23.2223 4.90345C23.2114 4.07347 23.5506 3.33085 24.0978 2.78481Z",
    fill: "url(#paint5_linear_350_14)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9473 14.5247C19.4906 14.5247 14.2595 19.7448 14.2595 26.1881C14.2595 32.6314 19.4906 37.8516 25.9473 37.8516C32.4041 37.8516 37.6351 32.6314 37.6351 26.1881C37.6242 19.7448 32.3931 14.5247 25.9473 14.5247ZM18.4072 18.6637C19.6219 17.4515 21.1321 16.5341 22.8174 16.0099C22.4891 16.3157 22.1499 16.687 21.7997 17.1129C21.2087 17.8446 20.6287 18.751 20.1472 19.8541C20.0596 19.8104 19.9721 19.7776 19.8845 19.7339C19.1842 19.4063 18.626 19.0896 18.2321 18.8493C18.2868 18.7838 18.3415 18.7183 18.4072 18.6637ZM17.5536 19.6356C17.9804 19.9087 18.626 20.2909 19.4577 20.6731C19.5672 20.7168 19.6657 20.7714 19.7751 20.8151C19.3374 22.0928 19.0419 23.5999 19.0091 25.3472H15.3211C15.4962 23.1958 16.295 21.2301 17.5536 19.6356ZM17.3347 32.4458C16.0871 30.7312 15.332 28.6453 15.2882 26.3738H19.02C19.0638 27.1382 19.2279 28.7982 19.7532 30.6766C19.797 30.8186 19.8298 30.9496 19.8736 31.0916C19.7313 31.1571 19.5781 31.2117 19.4468 31.2772C18.4619 31.7141 17.7396 32.1727 17.3347 32.4458ZM18.4072 33.7017C18.2649 33.5597 18.1226 33.4068 17.9804 33.2539C18.3743 32.9918 19.0419 32.5877 19.9393 32.1727C20.0268 32.1291 20.1144 32.0963 20.2019 32.0635C20.5193 32.9154 20.9132 33.7672 21.4276 34.5753C21.8325 35.2197 22.325 35.8312 22.8831 36.3773C21.1759 35.8531 19.6438 34.9248 18.4072 33.7017ZM25.433 36.8032C25.3454 36.8032 25.2688 36.7922 25.1813 36.7813C23.9556 36.137 23.0254 35.1541 22.3031 34.0184C21.8325 33.2867 21.4714 32.4785 21.165 31.6813C22.3578 31.2663 23.8024 30.9278 25.422 30.8732V36.8032H25.433ZM25.433 29.8466C23.671 29.9012 22.128 30.2616 20.8476 30.7094C20.6287 29.9886 20.4755 29.3006 20.3551 28.6672C20.2019 27.859 20.1253 27.171 20.0815 26.6796C20.0706 26.5704 20.0596 26.4611 20.0596 26.3738H25.433V29.8466ZM25.433 25.3472H20.0378C20.0706 23.7309 20.3332 22.3658 20.7272 21.1973C22.0295 21.6669 23.6163 22.0382 25.422 22.1037V25.3472H25.433ZM25.433 21.0663C23.7805 21.0117 22.314 20.6622 21.1102 20.2363C21.548 19.2425 22.0842 18.4234 22.6095 17.7573C23.2442 16.96 23.8899 16.4031 24.3605 16.0536C24.6013 15.8789 24.7982 15.7478 24.9296 15.6605C24.9843 15.6277 25.0281 15.6059 25.0609 15.584C25.1922 15.5731 25.3126 15.5622 25.4439 15.5622V21.0663H25.433ZM34.3411 19.6356C35.5996 21.2301 36.3985 23.1958 36.5626 25.3472H33.0278C32.995 23.5671 32.6886 22.0273 32.2399 20.7386C32.9184 20.4219 33.6297 20.0615 34.3411 19.6356ZM33.4765 18.6637C33.5313 18.7183 33.5969 18.7838 33.6516 18.8493C33.0388 19.2097 32.4369 19.5155 31.8459 19.7776C31.3754 18.7074 30.8063 17.8228 30.2263 17.1129C29.9089 16.7198 29.5806 16.3703 29.2851 16.0754C30.8829 16.6106 32.3165 17.4952 33.4765 18.6637ZM26.4617 15.5622C26.6477 15.5731 26.8338 15.584 27.0089 15.6058C27.3262 15.7915 28.4206 16.4795 29.4931 17.8446C29.9855 18.478 30.478 19.2425 30.9048 20.1708C29.3289 20.7496 27.8406 21.0226 26.4617 21.0772V15.5622ZM26.4617 22.0928C27.9609 22.0382 29.5806 21.7543 31.2769 21.1209C31.6818 22.3003 31.9663 23.6982 31.9991 25.3472H26.4617V22.0928ZM26.4617 26.3738H31.9773C31.9225 27.1492 31.7584 28.8091 31.2221 30.622C31.2112 30.6766 31.1893 30.7312 31.1674 30.7858C29.504 30.1852 27.9172 29.9012 26.4507 29.8466V26.3738H26.4617ZM26.8775 36.7704C26.7353 36.7813 26.6039 36.7922 26.4617 36.8032V30.8732C27.8187 30.9278 29.2851 31.1899 30.8391 31.7577C30.5327 32.5768 30.1497 33.385 29.6572 34.1276C28.9568 35.2087 28.0485 36.1479 26.8775 36.7704ZM33.4765 33.7017C32.2946 34.8811 30.8391 35.7766 29.2085 36.3008C29.7448 35.7766 30.2044 35.1869 30.5984 34.5644C31.0908 33.789 31.4739 32.959 31.7912 32.14C32.4807 32.4458 33.192 32.8061 33.9033 33.2539C33.7611 33.3959 33.6297 33.5488 33.4765 33.7017ZM32.1305 31.168C32.3822 30.349 32.5682 29.5627 32.6995 28.8637C32.8965 27.7716 32.9841 26.8871 33.0169 26.3738H36.6064C36.5626 28.6453 35.8185 30.7421 34.56 32.4458C33.7282 31.9325 32.9184 31.5066 32.1305 31.168Z",
    fill: "url(#paint6_linear_350_14)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1569 14.2735C16.0652 13.4435 16.9188 12.8866 17.5317 12.5371C17.8381 12.3624 18.0898 12.2422 18.254 12.1658C18.3415 12.133 18.4072 12.1003 18.451 12.0784L18.4947 12.0566H18.5057L18.1555 11.0956C18.1117 11.1174 16.4154 11.729 14.4675 13.5091C12.5195 15.2891 10.3089 18.2378 9.2583 22.8791L10.2651 23.1085C11.261 18.6855 13.3403 15.9335 15.1569 14.2735Z",
    fill: "url(#paint7_linear_350_14)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4766 12.0675L33.5203 12.0893C33.5641 12.1112 33.6298 12.133 33.7173 12.1767C33.8815 12.2532 34.1332 12.3733 34.4396 12.548C35.0524 12.8975 35.906 13.4545 36.8144 14.2844C38.631 15.9444 40.7103 18.6964 41.7062 23.1194L42.713 22.89C41.6733 18.2596 39.4627 15.3001 37.5038 13.52C35.5559 11.7399 33.8596 11.1283 33.8158 11.1065L33.4766 12.0675Z",
    fill: "url(#paint8_linear_350_14)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1372 40.0685L33.0825 40.1013C33.0388 40.1231 32.984 40.1668 32.9074 40.2105C32.7433 40.2979 32.5025 40.4289 32.1852 40.5818C31.5395 40.8767 30.5983 41.237 29.3945 41.4882C26.976 41.9906 23.5287 42.0561 19.3483 40.2869L18.9434 41.2261C23.3208 43.0936 27.0198 43.0281 29.6025 42.4929C32.1961 41.9578 33.6844 40.9422 33.7173 40.9203L33.1372 40.0685Z",
    fill: "url(#paint9_linear_350_14)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_350_14",
    x1: 2.42491,
    y1: 35.7167,
    x2: 17.0432,
    y2: 35.7167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0949,
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2947,
    stopColor: "#011E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4315,
    stopColor: "#012C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5231,
    stopColor: "#014270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6888,
    stopColor: "#006197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8782,
    stopColor: "#0089C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0089C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_350_14",
    x1: 6.00773,
    y1: 28.6125,
    x2: 13.4181,
    y2: 28.6125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0949,
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2947,
    stopColor: "#011E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4315,
    stopColor: "#012C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5231,
    stopColor: "#014270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6888,
    stopColor: "#006197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8782,
    stopColor: "#0089C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0089C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_350_14",
    x1: 35.1974,
    y1: 35.7167,
    x2: 49.8156,
    y2: 35.7167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0949,
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2947,
    stopColor: "#011E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4315,
    stopColor: "#012C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5231,
    stopColor: "#014270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6888,
    stopColor: "#006197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8782,
    stopColor: "#0089C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0089C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_350_14",
    x1: 38.7801,
    y1: 28.6125,
    x2: 46.1905,
    y2: 28.6125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0949,
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2947,
    stopColor: "#011E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4315,
    stopColor: "#012C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5231,
    stopColor: "#014270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6888,
    stopColor: "#006197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8782,
    stopColor: "#0089C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0089C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_350_14",
    x1: 18.929,
    y1: 12.012,
    x2: 33.5472,
    y2: 12.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0949,
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2947,
    stopColor: "#011E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4315,
    stopColor: "#012C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5231,
    stopColor: "#014270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6888,
    stopColor: "#006197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8782,
    stopColor: "#0089C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0089C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_350_14",
    x1: 22.5118,
    y1: 4.90782,
    x2: 29.9222,
    y2: 4.90782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0949,
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2947,
    stopColor: "#011E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4315,
    stopColor: "#012C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5231,
    stopColor: "#014270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6888,
    stopColor: "#006197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8782,
    stopColor: "#0089C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0089C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_350_14",
    x1: 14.2596,
    y1: 26.1796,
    x2: 37.6273,
    y2: 26.1796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0949,
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2947,
    stopColor: "#011E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4315,
    stopColor: "#012C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5231,
    stopColor: "#014270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6888,
    stopColor: "#006197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8782,
    stopColor: "#0089C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0089C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_350_14",
    x1: 9.26202,
    y1: 17.103,
    x2: 18.5048,
    y2: 17.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0949,
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2947,
    stopColor: "#011E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4315,
    stopColor: "#012C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5231,
    stopColor: "#014270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6888,
    stopColor: "#006197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8782,
    stopColor: "#0089C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0089C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_350_14",
    x1: 33.4681,
    y1: 17.103,
    x2: 42.7109,
    y2: 17.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0949,
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2947,
    stopColor: "#011E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4315,
    stopColor: "#012C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5231,
    stopColor: "#014270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6888,
    stopColor: "#006197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8782,
    stopColor: "#0089C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0089C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_350_14",
    x1: 18.941,
    y1: 41.4473,
    x2: 33.718,
    y2: 41.4473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0949,
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2947,
    stopColor: "#011E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4315,
    stopColor: "#012C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5231,
    stopColor: "#014270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6888,
    stopColor: "#006197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8782,
    stopColor: "#0089C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0089C8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutsourcingIcon);
export default __webpack_public_path__ + "static/media/outsourcingIcon.f7160b48dca98a98587cf85517b1667d.svg";
export { ForwardRef as ReactComponent };